import { useRef, cloneElement, ReactElement } from 'react';

interface CommentAttachmentButtonProps {
  onFileSelect: (file: File) => void;
  children: ReactElement;
}

const CommentAttachmentActionWrapper = ({
  onFileSelect,
  children,
}: CommentAttachmentButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const files = event.target.files;
    if (files && files[0]) {
      onFileSelect(files[0]);
      event.target.value = '';
    }
  };

  const handleButtonClick = (): void => {
    fileInputRef.current?.click();
  };

  return (
    <>
      {cloneElement(children, { onClick: handleButtonClick })}
      <input
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept="image/jpeg, image/png"
        type="file"
        onChange={handleFileChange}
      />
    </>
  );
};

export default CommentAttachmentActionWrapper;
